// @ts-nocheck
interface CyberSweepClient {
  id: string;
  auditId: string;
  firstName: string;
  lastName: string;
  cyberSweepStartDate: string;
  cyberSweepEndDate: string;
  cyberSweepStage: string;
  cyberSweepStatus: string;
  clientPersonalPhone: string;
  personalEmailAddress: string;
  currentHomeAddress: string;
  currentCity: string;
  currentState: string;
  currentZipPostal: string;
  previousHomeAddress: string;
  previousCity: string;
  previousState: string;
  previousZipPostal: string;
  csReportsRecipients: string;
  initialReport: boolean;
  initialReportDate: string;
  finalReport: boolean;
  finalReportDate: string;
  quarterlySweep1: boolean;
  sweep1Date: string;
  quarterlySweep2: boolean;
  sweep2Date: string;
  quarterlySweep3: boolean;
  sweep3Date: string;
  quarterlySweep4: boolean;
  sweep4Date: string;
  profession: string;
  otherProfession: string;
  dummyEmailAddress: string;
  dummyPassword: string;
}

class CyberSweepClientService {
  private static instance: CyberSweepClientService;
  private clients: Map<string, CyberSweepClient> = new Map();
  private listeners: Array<() => void> = [];

  static getInstance(): CyberSweepClientService {
    if (!CyberSweepClientService.instance) {
      CyberSweepClientService.instance = new CyberSweepClientService();
    }
    return CyberSweepClientService.instance;
  }

  constructor() {
    this.initializeMockData();
  }

  private initializeMockData() {
    // Mock client data
    const mockClients: CyberSweepClient[] = [
      {
        id: 'client_001',
        auditId: 'CSAudit-1001',
        firstName: 'John',
        lastName: 'Smith',
        cyberSweepStartDate: '2025-01-15',
        cyberSweepEndDate: '2026-01-15',
        cyberSweepStage: 'Active Monitoring',
        cyberSweepStatus: 'In Progress',
        clientPersonalPhone: '(555) 123-4567',
        personalEmailAddress: 'john.smith@email.com',
        currentHomeAddress: '123 Main Street',
        currentCity: 'Los Angeles',
        currentState: 'CA',
        currentZipPostal: '90001',
        previousHomeAddress: '456 Oak Avenue',
        previousCity: 'San Diego',
        previousState: 'CA',
        previousZipPostal: '92101',
        csReportsRecipients: 'john.smith@email.com',
        initialReport: true,
        initialReportDate: '2025-02-01',
        finalReport: false,
        finalReportDate: '',
        quarterlySweep1: true,
        sweep1Date: '2025-04-15',
        quarterlySweep2: false,
        sweep2Date: '',
        quarterlySweep3: false,
        sweep3Date: '',
        quarterlySweep4: false,
        sweep4Date: '',
        profession: 'Software Engineer',
        otherProfession: '',
        dummyEmailAddress: 'audit.jsmith001@gmail.com',
        dummyPassword: 'TempPass123!'
      },
      {
        id: 'client_002',
        auditId: 'CSAudit-1010',
        firstName: 'Amanda',
        lastName: 'Johnson',
        cyberSweepStartDate: '2025-01-15',
        cyberSweepEndDate: '2026-01-15',
        cyberSweepStage: 'Active Monitoring',
        cyberSweepStatus: 'In Progress',
        clientPersonalPhone: '(555) 123-4567',
        personalEmailAddress: 'amanda.johnson@email.com',
        currentHomeAddress: '123 Main Street',
        currentCity: 'Los Angeles',
        currentState: 'CA',
        currentZipPostal: '90001',
        previousHomeAddress: '456 Oak Avenue',
        previousCity: 'San Diego',
        previousState: 'CA',
        previousZipPostal: '92101',
        csReportsRecipients: 'amanda.johnson@email.com, spouse@email.com',
        initialReport: true,
        initialReportDate: '2025-02-01',
        finalReport: false,
        finalReportDate: '',
        quarterlySweep1: true,
        sweep1Date: '2025-04-15',
        quarterlySweep2: true,
        sweep2Date: '2025-07-15',
        quarterlySweep3: false,
        sweep3Date: '',
        quarterlySweep4: false,
        sweep4Date: '',
        profession: 'Healthcare Professional',
        otherProfession: '',
        dummyEmailAddress: 'audit.ajohnson002@gmail.com',
        dummyPassword: 'SecurePass456!'
      }
    ];

    mockClients.forEach(client => {
      this.clients.set(client.id, client);
    });
  }

  subscribe(listener: () => void): () => void {
    this.listeners.push(listener);
    return () => {
      this.listeners = this.listeners.filter(l => l !== listener);
    };
  }

  private notifyListeners() {
    this.listeners.forEach(listener => listener());
  }

  getClient(clientId: string): CyberSweepClient | undefined {
    return this.clients.get(clientId);
  }

  getClientByAuditId(auditId: string): CyberSweepClient | undefined {
    return Array.from(this.clients.values()).find(c => c.auditId === auditId);
  }

  getAllClients(): CyberSweepClient[] {
    return Array.from(this.clients.values());
  }

  updateClient(clientId: string, updates: Partial<CyberSweepClient>): boolean {
    const client = this.clients.get(clientId);
    if (client) {
      this.clients.set(clientId, { ...client, ...updates });
      this.notifyListeners();
      return true;
    }
    return false;
  }

  updateClientField(clientId: string, fieldName: string, value: any): boolean {
    const client = this.clients.get(clientId);
    if (client) {
      this.clients.set(clientId, { ...client, [fieldName]: value });
      this.notifyListeners();
      return true;
    }
    return false;
  }

  createClient(client: CyberSweepClient): boolean {
    if (this.clients.has(client.id)) {
      return false;
    }
    this.clients.set(client.id, client);
    this.notifyListeners();
    return true;
  }

  deleteClient(clientId: string): boolean {
    const deleted = this.clients.delete(clientId);
    if (deleted) {
      this.notifyListeners();
    }
    return deleted;
  }
}

export const cyberSweepClientService = CyberSweepClientService.getInstance();
export type { CyberSweepClient };